import React from 'react';
import {withNamespaces} from "react-i18next";

const ContentPackageStatus = ({t, packageStatus}) => {
    let iconClass = "";
    let iconColor = "";
    switch(packageStatus) {
        case "new":
            iconClass = "fas fa-plus-circle";
            iconColor = "text-info";
            break;
        case "in_progress":
            iconClass = "fas fa-spinner";
            iconColor = "text-primary";
            break;
        case "failed":
            iconClass = "fas fa-exclamation-circle";
            iconColor = "text-warning";
            break;
        case "sent":
            iconClass = "fas fa-check-circle";
            iconColor = "text-success";
            break;
        case "to_delete":
            iconClass = "fas fa-trash";
            iconColor = "text-danger";
            break;
        case "deleted":
            iconClass = "fas fa-trash";
            iconColor = "text-danger";
            break;
        case "error":
            iconClass = "fas fa-exclamation-triangle";
            iconColor = "text-danger";
            break;
        case "error_device_turned_off":
            iconClass = "fas fa-exclamation-triangle";
            iconColor = "text-danger";
            break;
        default:
            iconClass = "fas fa-info";
            break;
    }

    return (
        <div>
            <i className={`${iconClass} ${iconColor}`}> </i> &nbsp; <b>{t('status-' + packageStatus)}</b>
        </div>
    )

};
export default withNamespaces()(ContentPackageStatus);
